// Sort default is not driven by Umbraco. Use whatever is set on the page (URL)
// if present, otherwise fall back to "ourpick" / "asc". Shared by SearchForm
// (which seeds SortContext for the dropdown) and Location (which fetches the
// results), so the sort shown and the sort requested can't drift apart.
const isSet = (value) => value && value !== "null" && value !== "undefined";

const resolveDefaultSort = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlSort = urlParams.get("Sort");
  const urlSortDirection = urlParams.get("SortDirection");

  return {
    sort: isSet(urlSort) ? urlSort : "ourpick",
    sortDirection: isSet(urlSortDirection) ? urlSortDirection : "asc",
  };
};

export default resolveDefaultSort;
